import dayjs from 'dayjs';

import { useSimulatedClusterDemoUi } from '@cast/infrastructure-demo';
import {
  defaultQueryParamKeys,
  DateRangeFilter,
  RangePickerQueryParamKeys,
  TimeRangeConstraints,
} from '@cast/shared-date-ui';
import { useTimeRangeSelection } from 'hooks/useTimeRangeSelection';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const QUERY_PARAM_KEYS: RangePickerQueryParamKeys =
  defaultQueryParamKeys;

export const PRESENT_FILTER_PRESETS = [
  DateRangeFilter.Last15Mins,
  DateRangeFilter.Last30Mins,
  DateRangeFilter.LastHour,
  DateRangeFilter.Last24Hours,
  DateRangeFilter.Last7Days,
  DateRangeFilter.Last30Days,
];

export const useClusterDashboardTimeRangeSelection = () => {
  const { cluster } = useCluster();
  const isSimulatedClusterDemoUi = useSimulatedClusterDemoUi();

  const constraints: TimeRangeConstraints = {
    minDate: ({ timezone }) =>
      dayjs.utc(cluster.createdAt).tz(timezone).startOf('day').toISOString(),
    maxDate: () => dayjs.utc().toISOString(),
  };

  return useTimeRangeSelection({
    queryParamKeys: QUERY_PARAM_KEYS,
    initialState: {
      preset: DateRangeFilter.Last24Hours,
      timeZone: isSimulatedClusterDemoUi ? 'UTC' : undefined,
    },
    constraints,
    allowTimeInput: true,
  });
};
